<img src="/static/images/gapgraph.png" class="d-block w-100"/>
